import { useEffect } from "react";
import { useAsyncFn, useLatest } from "react-use";

type PromiseValue<T> = T extends Promise<infer D> ? D : unknown;
type FnReturningPromise = (...args: any[]) => Promise<any>;

interface StatusType {
    loading: boolean;
    error: any;
}

export default function useExamInfo<T extends FnReturningPromise>(
    callback: T,
    currentData: any
) {
    type DataType = PromiseValue<ReturnType<T>> | null;
    const [state, doFetch] = useAsyncFn(callback, [currentData]);
    const doFetchLatest = useLatest(doFetch);

    function refresh() {
        return doFetchLatest.current();
    }

    useEffect(() => {
        if (currentData) {
            doFetch(currentData);
        }
    }, [currentData]);

    return [state.value, state, refresh] as unknown as [
        DataType,
        StatusType,
        () => Promise<any>
    ];
}
